import { displayToast, initializeModals, sendAppsignalError } from "../modules/utils";

class PaymentSignup {
  constructor(node) {
    this.element = node;
    this.summaryWrapper = this.element.querySelector(".js-summary-wrapper");
    this.shipmentOptions = this.element.querySelectorAll(".js-radio-button");
    this.paymentOptions = this.element.querySelectorAll(".js-payment-radio-button");
    this.paymentWrapper = this.element.querySelector(".js-payment-wrapper");

    this.fetchUrl = new URL(this.element.dataset.fetchUrl, window.location);
    this.shortSummaryUrl = new URL(this.element.dataset.shortSummaryUrl, window.location);

    this.initialize();
  }

  initialize() {
    this.paymentWrapper.addEventListener("ajax:post", (e) => {
      this.paymentWrapper.innerHTML = e.detail.html;

      initializeModals(this.paymentWrapper);
      this.reinitializeSummary();
    });

    this.shipmentOptions.forEach((radioButton) => {
      radioButton.addEventListener("change", () => {
        const { name, value } = radioButton;

        this.shortSummaryUrl.searchParams.set(name, value);
        this.fetchShortSummary();
      });
    });

    this.paymentOptions.forEach((radioButton) => {
      radioButton.addEventListener("change", () => {
        const { name, value } = radioButton;

        this.shortSummaryUrl.searchParams.set(name, value);
        this.fetchShortSummary();
      });
    });

    this.reinitializeSummary();
  }

  reinitializeSummary() {
    this.productOptions = this.element.querySelectorAll(".js-product-option");

    this.productOptions.forEach((productOption) => {
      productOption.addEventListener("change", () => {
        this.fetchShortSummary();
      });
    });
  }

  fetchShortSummary() {
    this.summaryWrapper.classList.add("is-loading");

    fetch(this.shortSummaryUrl, {
      retries: 3,
      retryDelay: 1000,
    })
      .then((response) => {
        this.response = response;

        if (response.status == 200) {
          return response.json();
        }

        throw new Error("Short summary fetch failed");
      })
      .then((data) => {
        const { html } = data;

        this.summaryWrapper.innerHTML = html;
        this.reinitializeSummary();
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorFetch);
        sendAppsignalError(e, "PaymentSignup", {
          response: this.response,
        });
      })
      .finally(() => {
        this.summaryWrapper.classList.remove("is-loading");
      });
  }
}

const payment = document.querySelector("[ data-js='payment-signup']");

if (payment) {
  new PaymentSignup(payment);
}
